import { useMemo, useState } from "react";
import { Grid } from "antd";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import useHotelsSearch from "../../hooks/useHotelsSearch";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import { applyFilter, applySorter, groupBy } from "src/utility";
import { ALL_FILTERS, ALL_SORTERS, GROUP_OPTIONS, INITIAL_SORTER_VALUE, getFacilityCategories } from "../../constants";
import { transformFormToFilters, transformFormToSorters } from "./utils";
import HotelListingWeb from "./layouts/HotelListing.web";
import HotelListingMobile from "./layouts/HotelListing.mobile";
import { Navigate } from "react-router-dom";
import HotelsListingProvider from "./context/HotelsListingContext";

const HotelListingComponent = withConditionalComponent(HotelListingWeb, HotelListingMobile);

export default function HotelsListing() {
  const { hotels, isPollingDone, isFetching, hasFirstResults, pointsFactor, searchObject, notFound, sessionId } = useHotelsSearch();
  const [filters, setFilters] = useState<any>({});
  const [sorter, setSorter] = useState<any>(INITIAL_SORTER_VALUE);

  const { facilities: selectedFacilities, ...restFilters } = filters;
  const filteredData = hotels
    .filter(applyFilter(ALL_FILTERS, transformFormToFilters(restFilters)))
    .filter((hotel) => {
      if (!selectedFacilities?.length) return true;
      const categories = getFacilityCategories(hotel.categorizedFacilities);
      return selectedFacilities.every((category: string) => categories.includes(category));
    });
  const fullDataGroups = useMemo(() => groupBy(hotels, GROUP_OPTIONS), [hotels, GROUP_OPTIONS]);
  const filteredDataGroups = useMemo(() => groupBy(filteredData, GROUP_OPTIONS), [filteredData, GROUP_OPTIONS]);

  const hotelsSorted = applySorter(ALL_SORTERS, transformFormToSorters(sorter))(filteredData);
  const dataCount = { segmentCount: filteredData.length, totalCount: hotels.length };

  const contextValue = useMemo(
    () => ({ filters, setFilters, sorter, setSorter, searchObject, dataCount, isFetching, isPollingDone, hasFirstResults, pointsFactor, sessionId }),
    [filters, sorter, searchObject, dataCount, isFetching, isPollingDone, hasFirstResults, pointsFactor, sessionId],
  );
  const isLargeScreen = !!Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];

  if (notFound) return <Navigate to="/not-found" />;
  return (
    <HotelsListingProvider value={contextValue}>
      <HotelListingComponent
        trigger={isLargeScreen}
        props={{
          fullDataGroups,
          hotels: hotelsSorted,
          filteredDataGroups,
        }}
      />
    </HotelsListingProvider>
  );
}
